import browse from './browse';
import notifications from './notifications';
import roles from './roles';
import opportunities from './opportunities';

const { ORGADMIN_ROLE, EMPLOYEE_ROLE, SCHOOLADMIN_ROLE, EDUCATOR_ROLE, DE_ROLE, STUDENT_ROLE, GROUPADMIN_ROLE } = roles;

// API Domain from environment variable
export const API_DOMAIN = import.meta.env.VITE_API_URL;

// Maps singular entity type names to their correct API route plural forms.
// Avoids naive `${type}s` concatenation which breaks for irregular plurals (e.g. opportunity → opportunitys).
export const ENTITY_PLURAL_MAP = {
    request: 'requests',
    opportunity: 'opportunities',
};

// metadata key from Auth0
export const DE_ADMIN = 'DE Admin';

export const ROLE_DISPLAY_MAP = {
    [EDUCATOR_ROLE]: 'Educator',
    [SCHOOLADMIN_ROLE]: 'School Admin',
    [EMPLOYEE_ROLE]: 'Volunteer',
    [DE_ROLE]: 'DE Admin',
    [ORGADMIN_ROLE]: 'Organization Admin',
};

// roles as currently stored in Auth0 metadata
export const METADATA_ROLES = {
    [ORGADMIN_ROLE]: 'Organization Admin',
};

export const MEMBER_ROLES = [EDUCATOR_ROLE, EMPLOYEE_ROLE];
export const ADMIN_ROLES = [ORGADMIN_ROLE, SCHOOLADMIN_ROLE, DE_ROLE];
export const BLOCKED_ROLES = [STUDENT_ROLE];

export const partnerRoles = [ORGADMIN_ROLE, EMPLOYEE_ROLE, DE_ROLE, GROUPADMIN_ROLE];
export const educatorRoles = [EDUCATOR_ROLE, SCHOOLADMIN_ROLE];

export const partnerMap = {
    [EDUCATOR_ROLE]: [EMPLOYEE_ROLE],
    [EMPLOYEE_ROLE]: [EDUCATOR_ROLE],
    [ORGADMIN_ROLE]: [EMPLOYEE_ROLE, EDUCATOR_ROLE],
    [DE_ROLE]: [EMPLOYEE_ROLE, EDUCATOR_ROLE],
};

export const INVITE_MAX = 30;

// FORM VALUES
// stored here for consistency when used in multiple places

// request status values that display differently for different roles
export const draft = 'draft';
export const scheduled = 'scheduled';
export const completed = 'completed';
export const canceled = 'canceled';
export const actionRequired = 'action-required';
export const awaitingConfirmation = 'awaiting-confirmation';
export const pendingMatches = 'pending-matches';
export const published = 'published';

export const expired = 'expired';

export const pastStatuses = [completed, expired, canceled];
export const futureStatuses = [draft, scheduled, actionRequired, awaitingConfirmation, pendingMatches];
export const allStatuses = [draft, expired, scheduled, completed, canceled, actionRequired, awaitingConfirmation, pendingMatches];
export const allHappyStatuses = [draft, scheduled, completed, actionRequired, awaitingConfirmation, pendingMatches];
export const allStatusesEmployee = [scheduled, completed, canceled, actionRequired, awaitingConfirmation, pendingMatches];
export const requestableStatuses = [actionRequired, pendingMatches];

export const employeeAcceptingApplications = [actionRequired, pendingMatches];
// statuses that can be considered "open for applications"
export const openStatuses = [awaitingConfirmation, pendingMatches, actionRequired];

// LOGIN MANAGEMENT
export const LOGIN_PREF_KEY = 'careers-app-login-pref';

export const baseAssetCategory = 'general';

export const ATLAS_APP_BASE_URL = 'https://thisiscareerconnect.discoveryeducation.com';

export const envMap = {
    development: 'dev.',
    qa: 'qa.',
    staging: 'stage.',
    production: '',
};

export { browse, notifications, roles, opportunities };
